import * as React from 'react';
import { StaticDetails } from '@shared-ui/retail-activities-static-details';
import { UitkSpacing } from 'uitk-react-spacing';
import { NavigationRefs } from '../../../utils/accessibility';
import { useStores } from '../../../utils/hooks';
import { ACTIVITY_DETAILS_BATCHING } from '../../../constants';
var ABOUT_THIS_ACTIVITY_CONTAINER = 'aboutThisActivityContainer';
export var StaticDetailsSection = function (_a) {
  var className = _a.className;
  var detailCriteriaStore = useStores().detailCriteriaStore;
  return React.createElement("div", {
    id: ABOUT_THIS_ACTIVITY_CONTAINER,
    "aria-label": "about this activity",
    className: className
  }, React.createElement(UitkSpacing, {
    margin: {
      large: {
        blockstart: 'six'
      }
    }
  }, React.createElement(StaticDetails, {
    jumplinkTabRefs: NavigationRefs,
    inputs: {
      activityId: detailCriteriaStore.activityId,
      dateRange: detailCriteriaStore.detailVariables.dateRange
    },
    batchKey: ACTIVITY_DETAILS_BATCHING
  })));
};